import React from "react";
import ReactApexChart from "react-apexcharts";
import { useTitle } from "../../../../../hooks/useTitle";
import { withAuth } from "../../../../../components/HOC/withAuth";
import CardContainer from "../../../../../components/CustomUI/CardContainer";
import { SectionSpinner, SectionEmpty } from "../../shared/utils";
import ProductionReportShell from "../ProductionReportShell";
import { useMachineProductionReport } from "../useMachineProductionReport";

const ProductionByMachineTotals = () => {
  useTitle("Rovion MES - Üretim Özeti");
  const {
    filters,
    machines,
    shifts,
    loading,
    derived,
    fetchData,
    toasts,
    dismissToast,
    chartColor,
  } = useMachineProductionReport();

  const content = () => {
    if (loading) return <SectionSpinner />;
    if (!derived) return <SectionEmpty />;
    const { machineTotals } = derived;
    if (!machineTotals.length)
      return <SectionEmpty msg="Makine verisi bulunamadı." />;

    return (
      <CardContainer title="Makine Başına Toplam Üretim">
        <ReactApexChart
          type="bar"
          series={[{ name: "Miktar", data: machineTotals.map((m) => m.total) }]}
          options={{
            chart: { type: "bar", toolbar: { show: false } },
            plotOptions: { bar: { horizontal: true, borderRadius: 4 } },
            colors: [chartColor],
            xaxis: { categories: machineTotals.map((m) => m.name) },
            dataLabels: {
              enabled: true,
              formatter: (v) => v.toLocaleString("tr-TR"),
            },
            grid: { borderColor: "#f0f2f5" },
            tooltip: { y: { formatter: (v) => v.toLocaleString("tr-TR") } },
          }}
          height={Math.max(220, machineTotals.length * 42)}
        />
      </CardContainer>
    );
  };

  return (
    <ProductionReportShell
      title="Üretim Özeti"
      filters={filters}
      machines={machines}
      shifts={shifts}
      onApply={fetchData}
      toasts={toasts}
      dismissToast={dismissToast}
    >
      {content()}
    </ProductionReportShell>
  );
};

export default withAuth(ProductionByMachineTotals);
